<template lang="pug">
.title-component {{ title }}
</template>
<script>
export default {
  name: "title-component",
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.title-component {
  @apply font-medium text-green-700;
}
</style>